import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap';
import { DoubleBounce } from 'better-react-spinkit'

import Masonry from 'react-masonry-component';
import config from 'react-global-configuration';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import { NavSpacer, LightBackground, SpinnerWrapper } from '../GeneralStyle'
import CompanyCard from '../internal/CompanyCard'
import { InfoBox, Uppercase } from '../OnePager/OnePageStyle'

import styled from 'styled-components'
import './PartnerGrid.css'

import debounce from 'lodash.debounce';
import searchIcon from '../../images/icons/search.png'
import noentryIcon from '../../images/noentry-icon.png'

@inject('partnerInformationStore')
@observer
class PartnerGrid extends Component {

  constructor(props) {
    super(props)

    this.state = {
      searchQuery: "",
      page: 0
    }

  }

  componentWillMount() {
    const { query } = this.props.match.params
    this.setState({ searchQuery: query || "" })
    this.props.partnerInformationStore.search(0, query || "", this.props.industry && this.props.industry.id)
  }

  handleSearchbarChange = e => {
    const value = e.target.value
    this.setState({ searchQuery: value, page: 0 })
    //this.debouncedSearch(value)
  }

  debouncedSearch = debounce((value) => {
    this.search()
  }, 1000)

  loadMore = () => {
    this.setState({page: this.state.page + 1 })
    this.search(this.state.page + 1);
  }

  search = (page, val) => {
    const value = val !== undefined ? val : this.state.searchQuery
    this.props.partnerInformationStore.search(page || 0, value, this.props.industry && this.props.industry.id)
    const base_url = this.props.industry ? '/industry/' + this.props.industry.slug : '/partners'
    //this.props.history.push(value ? base_url + "/q/" + value : base_url)
    window.history.replaceState(null, null, value ? base_url + "/q/" + value : base_url)

  }

  render() {

    const companyProfiles = [];

    const masonryOptions = {
      transitionDuration: 200
    };

    const { getFromId, results, setOrderby, orderby, maxResults, searching } = this.props.partnerInformationStore

    if ( results && results.length > 0) {
      results.map(( id, key ) => {
        const company = getFromId(id)
        return companyProfiles.push(
          <Col xs={12} sm={6} md={4} lg={4} key={key} className="card-wrapper">
              <CompanyCard
                companyName={company.name}
                logo={company.logo}
                website={company.website}
                shortname={company.shortname}
                address={company.billingAddress}
                phone={company.phone}
                industry={company.industry} />
          </Col>
        )
      })
    }

    return (
        <div style={{marginTop: '0px', overflow: 'visible', position: 'relative', zIndex: '2'}}>
            <SearchContainer style={{marginTop: '-96px'}}>
            <h2 style={{fontSize: '18px', marginBottom: '24px'}}>Finden Sie die passende Firma</h2>
            <SearchFormWrapper>
                <img src={searchIcon} className="search-icon" />
                <SearchInput type="search" value={ this.state.searchQuery } onChange={ this.handleSearchbarChange } onKeyDown={e => { if(e.key == 'Enter') this.search() }} />
                { this.state.searchQuery && <ClearIcon onClick={() => { this.setState({ searchQuery: "" }); this.search(0, "") } }>✖</ClearIcon> }
                <div className="sort-container">
                  <SearchSort value={ orderby || "sortingNumber"} onChange={e => { setOrderby(e.target.value); this.search() }}>
                    <option value="sortingNumber">Sortieren nach</option>
                    <option value="name">Name (absteigend)</option>
                    <option value="-name">Name (aufsteigend)</option>
                  </SearchSort>
                  <div className="sort-arrow"></div>
                </div>
                <SearchButton onClick={ () => this.search() }>suchen</SearchButton>
            </SearchFormWrapper>
            </SearchContainer>
            <InfoBox className={'content-wrapper'}>
            <Masonry
                className={"companyGrid2"}
                options={masonryOptions}
                disableImagesLoaded={false}
                updateOnEachImageLoad={true}>
                {
                results && !(searching && this.state.page === 0)
                    ? results.length > 0 ?
                      <div style={{width: '100%'}}>
                        { companyProfiles }
                        { maxResults > results.length &&
                          <Col xs={12} sm={12} md={12} lg={12}> {
                            searching ? <SpinnerWrapper><DoubleBounce color={"#DAB777"} size={64} /></SpinnerWrapper>
                            : <LoadMore onClick={ this.loadMore }>mehr laden</LoadMore>
                          }</Col>
                        }
                      </div>
                    :
                    <div className="noentry-container">
                      <img src={noentryIcon} style={{marginBottom: '32px'}}/>
                      <p className="noentry-text">Es wurden keine Ergebnisse zu Ihrer Suchanfrage gefunden</p>
                    </div>
                    : <SpinnerWrapper><DoubleBounce color={"#DAB777"} size={64} /></SpinnerWrapper>
                }
            </Masonry>
            </InfoBox>
        </div>
    )
  }
}

const LoadMore = styled.div`
  width: 100%;
  color: black;
  text-align: center;
  cursor: pointer;
`

const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  margin: 0 auto;
  @media (max-width: 768px){
    margin-left: 32px;
    margin-right: 32px;
  }
`

const SearchFormWrapper = styled.div`
  position: relative;
  display: flex;
  background: white;
  border-radius: 4px;
  /* padding: 16px; */
  @media (max-width: 768px){
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
  }
`

const SearchInput = styled.input`
  height: 40px;
  padding: 4px 16px 4px 44px;
  margin: 16px 0 16px 16px;
  border-bottom: none;
  color: black;
  width: 360px;
  border-right: 1px solid black;
  @media (max-width: 768px){
    width: 75%;
    flex: 1;
  }
`
const SearchButton = styled.button`
  /* height: cacl(40px + 32px);
  margin-top: -16px;
  margin-bottom: -16px; */
  background: blue;
  padding: 16px 32px;
  appearance: none;
  -webkit-appearance: none;
  border: none;
  color: white;
  background: #212D3D;
  transition: all .25s ease-in-out;
  position: relative;
  border-radius: 0 5px 5px 0;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.95;
  }

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
    flex-basis: 100%;
    border-radius: 0 0 5px 5px;
  }
`

const ClearIcon = styled.div`
  color: black;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: calc(360px + 16px - 24px - 12px);
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .25s ease-in-out;
  cursor: pointer;
  padding-top: 4px;
  @media (max-width: 768px){
    left: auto;
    right: calc(1em + 48px + 12px);
    top: 40px;
    padding-top: 0;
  }
`

const SearchSort = styled.select`
  border: none;
  color: black;
  width: 100%;
  margin: 0 24px;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 24px;
  cursor: pointer;

  @media (max-width: 768px){
    flex-grow: 1;
    margin-left: 16px;
  }
  &:focus {
    outline: none;
  }
`

export default withRouter(PartnerGrid);



// WEBPACK FOOTER //
// /src/components/partner/PartnerGrid.js